import { Box, Drawer as MuiDrawer, type DrawerProps } from '@mui/material';

import { DrawerHeader } from '../DrawerHeader/DrawerHeader';

type Props = DrawerProps & {
  padding?: 'small' | 'medium';
};

export const Drawer = ({ children, padding = 'medium', ...rest }: Props) => {
  return (
    <MuiDrawer {...rest}>
      <Box
        height="100%"
        p={{
          sm: padding === 'medium' ? 4 : 1,
          xs: padding === 'medium' ? 3 : 1,
        }}
      >
        {children}
      </Box>
    </MuiDrawer>
  );
};

Drawer.Header = DrawerHeader;
